<template>
    <Link :href="l.link" @click="$emit('clicked', index)" :class="['nav-link anim', {'active': $page.component === l.component || ($page.component?.indexOf('MBB') == 0 && l.component?.indexOf('MBB') == 0 && this.$options.name=='NavigationLink')}]">
        <img v-if="l.icon" :src="`/images/icons/${l.icon}`" class="z-20 icon w-6 h-6 origin-center float-left" aria-hidden="true" :alt="l.label" />
        <img v-if="l.icon && l.icon !='adam-wood.svg'" :src="`/images/icons/${l.icon}`" class="shadow z-10 w-8 h-2 origin-center mb-2" aria-hidden="true" :alt="l.label" />
        <img v-else :src="`/images/icons/tv.png`" class="shadow z-10 w-10 h-2 origin-center mb-2" aria-hidden="true" :alt="l.label" />
        <div class="label pl-0 text-base font-bold uppercase text-center whitespace-nowrap">
            {{ l.label }}
        </div>
    </Link>
</template>

<script>
    import { Link } from '@inertiajs/vue3';

    export default {
        name: "NavigationLink",
        emits: ['clicked'],
        components: { Link },
        props: ['l', 'index'],
        computed: {},
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {

        }
    }
</script>
